export default "__VITE_ASSET__BdCzyIs5__"